import { Component, OnInit } from '@angular/core';
import {  MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-filter-saved-search',
    templateUrl: './filter-saved-search.component.html',
    styleUrls: ['./filter-saved-search.component.scss'],
    standalone: false
})
export class FilterSavedSearchComponent implements OnInit {
    constructor(
        private readonly matDialogRef: MatDialogRef<FilterSavedSearchComponent>,
    ) { }

    ngOnInit() { }

    close(req?: { reqType: 'New' | 'Saved' }) {
        this.matDialogRef.close(req);
    }

    newFilter() {
        this.close({ reqType: "New" });
    }

    useSavedSearch() {
        this.close({ reqType: "Saved" });
    }
}
